import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'calsoft-video-hero-background',
  templateUrl: './video-hero-background.component.html',
  styleUrls: ['./video-hero-background.component.scss']
})
export class VideoHeroBackgroundComponent {
  videoUrl = 'https://video.wixstatic.com/video/11062b_bc12126e841b46afaab4b81994fb9639/1080p/mp4/file.mp4';
  posterImage = 'https://static.wixstatic.com/media/11062b_bc12126e841b46afaab4b81994fb9639f000.jpg/v1/fill/w_1513,h_438,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/11062b_bc12126e841b46afaab4b81994fb9639f000.jpg';

  @ViewChild('backgroundVideo') videoRef!: ElementRef<HTMLVideoElement>;

  ngAfterViewInit() {
    this.setupVideoAutoplay();
  }

  private setupVideoAutoplay() {
    const video = this.videoRef.nativeElement;
    
    // Modern browsers require promise-based play
    const playPromise = video.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        // Autoplay was prevented - mute and try again
        video.muted = true;
        video.play().catch(e => console.log('Autoplay prevented:', e));
      });
    }
  }

  learnMore() {
    window.open('https://www.calsoftgroup.com/', '_blank');
  }
}
